// extracted by css-extract-rspack-plugin
export default {"fullWidthLabelEditing":"src-wab-client-components-widgets-EditableLabel-EditableLabel-module__fullWidthLabelEditing-tCNmJs","inputBox":"src-wab-client-components-widgets-EditableLabel-EditableLabel-module__inputBox-wxxFQ8"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fullWidthLabelEditing\":\"src-wab-client-components-widgets-EditableLabel-EditableLabel-module__fullWidthLabelEditing-tCNmJs\",\"inputBox\":\"src-wab-client-components-widgets-EditableLabel-EditableLabel-module__inputBox-wxxFQ8\"}";
        // 1793541993762
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  